import { RestClient } from '@pegasus/rest-client';
export const getVoucherMessages = async (localeCode) => {
    try {
        return await RestClient.get(`/api/contentful/voucher-messages/${localeCode}`)
            .acceptStatusCodes([200])
            .send()
            .then(res => res.json());
    }
    catch (e) {
        return [];
    }
};
//# sourceMappingURL=service.js.map